import React from 'react';
import './Header.css';

interface HeaderProps {
  currentStep: 'Evaluation' | 'Analysis' | 'Action';
  iconSrc: string;
  iconAlt: string;
  title: string;
  subtitle: string;
}

const Header: React.FC<HeaderProps> = ({ currentStep, iconSrc, iconAlt, title, subtitle }) => {
  return (
    <header className="new-header-outer-container">
      <div className="new-header-inner-container">
        <div className="new-header-top-section">
          <div className="new-header-title-area">
            <img
              src={iconSrc}
              alt={iconAlt}
              className="new-header-icon"
            />
            <div className="new-header-text-content">
              <p className="new-header-title">
                {title}
              </p>
              <p className="new-header-subtitle">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
        <div className="new-header-progress-section">
          <div className={`new-header-progress-step ${currentStep === 'Evaluation' ? 'progress-step-active' : ''}`}>
            <div className="new-header-progress-bar new-header-progress-bar-evaluation"></div>
            <div className="new-header-progress-label">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="new-header-progress-icon"
              >
                <circle cx="7.5" cy="8" r="7" stroke="#36B8C9" />
                <path
                  d="M7.27 4.38H8.34V11.5H6.99V6.7H5.35V5.75L5.51 5.74C6.03 5.70667 6.42667 5.59 6.7 5.39C6.98 5.18333 7.17 4.84667 7.27 4.38Z"
                  fill="#36B8C9" />
              </svg>
              <span className="new-header-progress-text new-header-progress-text-evaluation">
                Evaluation
              </span>
            </div>
          </div>
          <div className={`new-header-progress-step ${currentStep === 'Analysis' ? 'progress-step-active' : ''}`}>
            <div className="new-header-progress-bar new-header-progress-bar-analyse"></div>
            <div className="new-header-progress-label">
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="new-header-progress-icon"
              >
                <circle cx="8.16675" cy="7.5" r="7" stroke="#206E79" />
                <path
                  d="M7.56675 9.86H11.2367V11H6.05675L6.08675 10.47C6.11341 9.92333 6.22675 9.43333 6.42675 9C6.67341 8.46 7.18341 8.01333 7.95675 7.66L8.65675 7.3C9.07008 7.1 9.36342 6.89667 9.53675 6.69C9.71008 6.48333 9.79675 6.22667 9.79675 5.92C9.79675 5.59333 9.69341 5.33667 9.48675 5.15C9.28008 4.95667 8.99341 4.86 8.62675 4.86C7.80675 4.86 7.39675 5.29333 7.39675 6.16H6.09675C6.09008 5.39333 6.30675 4.79667 6.74675 4.37C7.19341 3.93667 7.83341 3.72 8.66675 3.72C9.43341 3.72 10.0401 3.91333 10.4867 4.3C10.9334 4.68667 11.1567 5.19333 11.1567 5.82C11.1567 6.36 11.0067 6.82 10.7067 7.2C10.4067 7.57333 9.93008 7.92333 9.27675 8.25L8.61675 8.6C8.24341 8.8 7.98008 8.99 7.82675 9.17C7.68008 9.34333 7.59341 9.57333 7.56675 9.86Z"
                  fill="#206E79" />
              </svg>
              <span className="new-header-progress-text new-header-progress-text-analyse">
                Analysis
              </span>
            </div>
          </div>
          <div className={`new-header-progress-step ${currentStep === 'Action' ? 'progress-step-active' : ''}`}>
            <div className="new-header-progress-bar new-header-progress-bar-action"></div>
            <div className="new-header-progress-label">
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="new-header-progress-icon"
              >
                <circle cx="7.83325" cy="7.5" r="7" stroke="#206E79" />
                <path
                  d="M9.96325 7.2C10.3366 7.36 10.6299 7.59333 10.8433 7.9C11.0633 8.2 11.1733 8.55333 11.1733 8.96C11.1733 9.62 10.9333 10.15 10.4533 10.55C9.96659 10.9567 9.31659 11.16 8.50325 11.16C7.59659 11.16 6.90325 10.94 6.42325 10.5C5.94992 10.0533 5.71325 9.43333 5.71325 8.64H7.02325C7.04325 9.56 7.52325 10.02 8.46325 10.02C8.86992 10.02 9.18992 9.92 9.42325 9.72C9.65659 9.52 9.77325 9.25 9.77325 8.91C9.77325 8.54333 9.65325 8.26 9.41325 8.06C9.17325 7.86 8.83992 7.76 8.41325 7.76H7.88325V6.77H8.40325C9.23659 6.77 9.65325 6.44 9.65325 5.78C9.65325 5.48 9.54659 5.24667 9.33325 5.08C9.11992 4.90667 8.82659 4.82 8.45325 4.82C7.64659 4.82 7.22325 5.19667 7.18325 5.95H5.88325C5.89659 5.23667 6.12325 4.68667 6.56325 4.3C7.00992 3.91333 7.64325 3.72 8.46325 3.72C9.22992 3.72 9.83659 3.89667 10.2833 4.25C10.7366 4.59667 10.9633 5.07 10.9633 5.67C10.9633 6.35 10.6299 6.86 9.96325 7.2Z"
                  fill="#206E79" />
              </svg>
              <span className="new-header-progress-text new-header-progress-text-action">
                Action
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
